import sanityClient from "./sanityClient";

export const MEETUP_GROUP_URL = "https://www.meetup.com/ixda-stavanger";

// A meetup number from ?m= wins, then the override in Site Configuration, otherwise the newest
// event's link. overrideEvent finds the event behind an override link, so the page can show which
// meetup it is. netlify/functions/meetup-click.js makes the same choice when it counts the click.
const query = `{
  "requested": *[_type == "event" && defined(eventMeetupNo) && eventMeetupNo == $meetupNo][0]{eventMeetupNo, eventName, color, url},
  "override": *[_type == "siteConfig"][0].meetupLink,
  "newest": *[_type == "event" && defined(eventMeetupNo)] | order(eventMeetupNo desc)[0]{eventMeetupNo, eventName, color, url}
}{
  ...,
  "overrideEvent": *[_type == "event" && defined(^.override) && url == ^.override][0]{eventMeetupNo, eventName, color}
}`;

// The meetup number in ?m=62, or null when it is missing or not a whole number
export const toMeetupNo = (value) => (/^\d+$/.test(value || "") ? Number(value) : null);

// Returns { url, event }, where event is null when the link does not belong to an event.
// meetupNo comes from ?m=. A number without an event, or an event without a link, is ignored,
// so the link still goes to the current meetup.
export const fetchMeetupTarget = async (meetupNo = null) => {
  try {
    const { requested, override, newest, overrideEvent } = await sanityClient.fetch(query, { meetupNo });

    if (requested?.url) return { url: requested.url, event: requested };
    if (override) return { url: override, event: overrideEvent };
    if (newest?.url) return { url: newest.url, event: newest };
    return { url: MEETUP_GROUP_URL, event: null };
  } catch (error) {
    console.error("Error fetching meetup link:", error);
    return { url: MEETUP_GROUP_URL, event: null };
  }
};
